import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=4a29a4fa&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=4a29a4fa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29a4fa",
  null
  
)

export default component.exports